import { Input, Space, Button, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { EditOutlined, CheckOutlined } from '@ant-design/icons';

const LessonNameInput = ({ name, value, onChange }) => {
  const [editing, setEditing] = useState(false);
  const [prefix, setPrefix] = useState('');
  const [lecNumber, setLecNumber] = useState('');
  const [editable, setEditable] = useState(false);

  useEffect(() => {
    if (!value) return;

    const match = value.match(/^(.*?)(Lec\s*)(\d+)$/);
    if (match) {
      setPrefix(match[1] + match[2]); // 前缀 + Lec
      setLecNumber(match[3]); // 数字
      setEditable(true);
    } else {
      setPrefix(value);
      setLecNumber('');
      setEditable(false);
    }
  }, [value]);

  const save = () => {
    setEditing(false);
    if (editable) {
      onChange?.(`${prefix}${lecNumber}`);
    }
  };

  if (!editing) {
    return (
      <Space>
        <Tooltip title={value}>
          <span>{value}</span>
        </Tooltip>
        {editable && (
          <Button
            type="link"
            size="small"
            icon={<EditOutlined />}
            onClick={() => setEditing(true)}
          />
        )}
      </Space>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        padding: '4px 0',
        maxWidth: '100%',
      }}
    >
      <div
        style={{
          flexShrink: 0,
          whiteSpace: 'nowrap',
          marginRight: 8,
          fontSize: 14,
        }}
      >
        {prefix}
      </div>
      <Input
        type="number"
        value={lecNumber}
        autoFocus
        onChange={(e) => setLecNumber(e.target.value)}
        onPressEnter={save}
        style={{
          minWidth: 50,
          width: 'auto',
          flexShrink: 0,
        }}
        suffix={<Button type="link" icon={<CheckOutlined />} onClick={save} />}
      />
    </div>
  );
};

export default LessonNameInput;
